import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import ProgressiveImage from '../../../../../../components/global/ProgressiveImage';

const propTypes = {
  className: PropTypes.string,
  cardCategory: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    asset_image: PropTypes.shape({
      id: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    }),
    background_color: PropTypes.string,
    foreground_color: PropTypes.string,
  }).isRequired,
  onClick: PropTypes.func.isRequired,
};

const CardCategory = ({ className, cardCategory, onClick }) => {
  const classes = classNames({
    'card-category-box': true,
    [className]: !!className,
  });

  return (
    <div className="card-category-container">
      <a
        href="#"
        id={cardCategory.id}
        className={classes}
        role="button"
        onClick={event => {
          event.preventDefault();
          onClick(cardCategory);
        }}
        style={{
          backgroundColor: cardCategory.background_color
            ? `${cardCategory.background_color}11`
            : undefined,
        }}
      >
        <ProgressiveImage
          className="card-category-box-thumbnail"
          src={cardCategory.asset_image?.url}
          alt=""
        />
      </a>
      <div className="card-category-name">{cardCategory.name}</div>
    </div>
  );
};

CardCategory.propTypes = propTypes;

export default CardCategory;
